// utils/format.ts

/**
 * WHAT:
 *   Formats minutes into a human-readable time string.
 *
 * @param minutes - The number of minutes to format (can be null or undefined)
 *
 * @returns {string} Formatted time string (e.g., "2 h 30 min" or "45 min")
 *
 */
export const formatMinutes = (minutes?: null | number): string => {
  if (!minutes || minutes <= 0) {
    return "0 min";
  }

  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  return h > 0 ? `${String(h)} h ${String(m)} min` : `${String(m)} min`;
};
